import { Component } from '@angular/core';

import { NavController, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppSessionService } from '@shared/session/app-session.service';
import { PermissionCheckerService } from '@shared/auth/permission-checker.service';
import { Title } from '@angular/platform-browser';
import { Router, NavigationExtras } from '@angular/router';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { FarmerServiceServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppConsts } from '@shared/AppConsts';
import { HelpDeskService } from '@shared/help-desk/help-desk.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  AppConsts: AppConsts = AppConsts;
  public appPages = [
    {
      title: 'Home',
      url: '/main/home',
      icon: 'home',
      featureEnabled: true
    },
    {
      title:'Admin',
      url:'/main/admin',
      icon:'construct',
      roles: ["Role.Admin"],
      authorize:true,
      featureEnabled: true
    },
    {
      title:'Dashboard',
      url:'/main/dashboard',
      icon:'analytics',
      roles: ["Role.Admin"],
      authorize:true,
      featureEnabled: true
    },
    {
      title: 'Farmer Profile',
      url: '/main/farmer',
      icon: 'person',
      authorize: true,
      roles: ["Pages.Farmer"],
      featureEnabled: true
    },
    // {
    //   title: 'Certifications',
    //   url: "/main/certifications",
    //   icon: "list",
    //   authorize: true,
    //   roles: ["Pages.Certifications"],
    //   featureEnabled: AppConsts.enabledFeatures.main.certifications.menu
    // },
    {
      title: 'Farmers',
      url: "/main/farmers",
      icon: "list",
      authorize: true,
      roles: ["Pages.Farmers"],
      featureEnabled: AppConsts.enabledFeatures.main.farmers.menu
    },
    {
      title: 'Assessments',
      url: "/main/verifications",
      icon: "list",
      authorize: true,
      roles: ["Pages.Verifications"],
      featureEnabled: AppConsts.enabledFeatures.main.verifications.menu
    },
    {
      title: 'Users',
      url: '/main/users',
      icon: 'people',
      authorize: true,
      roles: ["Pages.Users"],
      featureEnabled: AppConsts.enabledFeatures.main.users.menu
    },
    {
      title: 'Help Desk',
      url: '',
      icon: 'help',
      authorize: true,
      roles: [],
      featureEnabled: true
    },
    {
      title: "Log Out",
      url: "/account/login", //      url: "/account/logout",
      icon: "log-out",
      authorize: true,
      featureEnabled: true
    },
    {
      title: "Log In",
      url: "/account/login",
      icon: "log-in",
      notLoggedIn: true,
      featureEnabled: true
    },
    {
      title: "Register",
      url: "/account/register",
      icon: "create",
      notLoggedIn: true,
      featureEnabled: true
    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private sessionService: AppSessionService,
    private permissionChecker: PermissionCheckerService,
    private router: Router,
    private appStorageService: AppStorageService,
    private farmerSvc: FarmerServiceServiceProxy,
    private helpDeskService: HelpDeskService,
    private navCtrl: NavController
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
  shouldShowPage(p): boolean {
    if (!p.featureEnabled)return false;
    if (p.notLoggedIn) return this.sessionService.user == null;
    if (p.authorize === undefined || p.authorize == false) return true;
    if (p.authorize && (p.roles == null || p.roles.length == 0))
      return this.sessionService.user != null;
    for (let r in p.roles) {
      if (this.permissionChecker.isGranted(p.roles[r])) return true;
    }
    return false;
  }

  goToPage(p) {
    if (
      p.title == 'Profile' &&
      this.sessionService.user != null
    ) {
      this.farmerSvc.getFarmerIdByUserId(this.sessionService.user.id).subscribe(farmerKunId => {
        const navigationExtras: NavigationExtras = {
          queryParams: {
            farmerId: farmerKunId
          }
        };
        this.router.navigate([p.url], navigationExtras);
      });
      return;
    }
    if (p.title == 'Help Desk') this.openHelpDeskPopup();
    // if logging out on farmer profile clear token over there after saving all the things
    if (p.title == 'Log Out' && this.router.url.indexOf('/main/farmer') == -1) this.appStorageService.clearToken();
    this.router.navigate([p.url]);
  }

  openHelpDeskPopup() {
    this.helpDeskService.openHelpDeskPopup();
  }

}
